module.exports = __webpack_public_path__ + "static/media/ascarl746066.cfa0f117.jpg";